<template>
  <div class="login-wrap">
    <div class="header">
      <div class="header-center fl">
        <div class="header-title">
          锦胜雾森后台登录界面
        </div>
        <div class="header-img"></div>
      </div>
      <div class="header-bottom fl"></div>
    </div>

    <div class="content">
      <el-col class="content-left" :lg="14" :md="12"></el-col>
      <el-col class="content-right" :lg="12" :md="12">
        <div class="right-infp">
          <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm"
                   class="demo-ruleForm login-container">
            <el-form-item prop="phone">
              <el-input type="text" v-model="ruleForm.phone" auto-complete="off"
                        placeholder="请输入手机号"></el-input>
            </el-form-item>
            <!--<div style="height: 1.5vh"></div>-->
            <el-form-item prop="code">
              <el-input type="text" v-model="ruleForm.code" auto-complete="off"
                        placeholder="请输入验证码"></el-input>
              <div @click="getCode" class="get-code">{{buttonText}}</div>
            </el-form-item>
            <!--<div style="height: 0.1vh"></div>-->
            <el-form-item class="right-infp-btn" :hide-label="true">
              <el-button class="btn" type="primary" @click="submitForm('ruleForm')" long size="large">
                登录
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import {getCodes, login} from '../api/userMG'

  export default {
    name: 'login',
    data() {
      return {
        logining: false,
        rememberpwd: false,
        buttonText: '获取验证码',
        canClick: true,
        second: 60,
        ruleForm: {
          phone: '',
          code: null,
        },
        codes: null,
        //rules前端验证
        rules: {
          code: [{required: true, message: '请输入验证码', trigger: 'blur'}],
          phone: [{required: true, message: '请输入账号', trigger: 'blur'}]
        }
      }
    },
    // 创建完毕状态(里面是操作)
    created() {
    },
    // 里面的函数只有调用才会执行
    methods: {
      getCode() {
        let myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (this.ruleForm.phone == '') {
          this.$message({
            type: 'error',
            message: '请填写手机号'
          })
          return false;
        } else if (!myreg.test(this.ruleForm.phone)) {
          this.$message({
            type: 'error',
            message: '请填写正确的手机号'
          })
          return false;
        }
        if (this.canClick) {
          getCodes({phone: this.ruleForm.phone, webType: 'backend'}).then(res => {
              this.codes = res.codes
              this.canClick = false
              this.$message({
                type: 'success',
                message: '发送成功'
              })
              this.timer()
            }
          )
        }
      },
      timer() {
        if (this.second > 0) {
          this.second--;
          this.buttonText = this.second + "s";
          setTimeout(this.timer, 1000);
        } else {
          this.second = 0;
          this.buttonText = "获取验证码";
          this.canClick = true;
        }
      },
      //获取info列表
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.logining = true
            login(this.ruleForm).then(res => {
              if (res.code == 200) {
                setTimeout(() => {
                  this.logining = false
                  // 缓存token
                  localStorage.setItem('logintoken', res.data.token)
                  // 缓存用户个人信息
                  localStorage.setItem('userdata', JSON.stringify(res.data.user))
                  this.$store.commit('login', 'true')
                  this.$router.push({path: '/home/index'})
                }, 1000)
              } else {
                this.$message.error(res.msg)
                this.logining = false
                return false
              }
            })
          } else {
            this.$message.error('请输入用户名和验证码')
            this.logining = false
            return false
          }
        })
      }
    }
  }
</script>

<style scoped>
  .login-wrap {
    background: url("/static/images/bj.jpg") no-repeat;
    background-size: cover;
    color: #ffffff;
    position: relative;
    width: 100vw;
    height: 90vh;
    margin: 0 auto;
    padding-top: 10vh;
  }

  .get-code:hover {
    cursor: pointer;
  }

  .get-code {
    width: 30%;
    right: 0px;
    position: absolute;
    color: #fff;
    background-color: rgb(0, 234, 255);
    margin-top: -40px !important;
    text-align: center;
  }

  /*头部*/
  .header {
    width: 100%;
    height: 20vh;
  }

  .header .header-center {
    width: 50%;
    height: 20vh;
    position: relative;
    margin: 0 auto;
  }

  .header .header-center .header-title {
    text-align: center;
    color: #ffffff;
    font-size: 1.8rem;
    line-height: 5vh;
  }

  .header .header-img {
    background: url("/static/images/head.gif") no-repeat center center;
    background-size: 100%;
    height: 100%;
    width: 100%;
    position: absolute;
    top: 2vh;
  }

  .content {
    width: 50%;
    height: 50vh;
    margin: 1rem auto 0 auto;
  }

  .content .content-left {
    width: 22rem;
    height: 22rem;
    background: url("/static/images/d.png") no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    float: left;
    margin-left: -5vw;
  }

  @-webkit-keyframes rotation {
    from {
      -webkit-transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
    }
  }

  .content .content-left {
    -webkit-transform: rotate(360deg);
    animation: rotation 15s linear infinite;
    -moz-animation: rotation 15s linear infinite;
    -webkit-animation: rotation 15s linear infinite;
    -o-animation: rotation 15s linear infinite;
  }

  .content .content-right {
    width: 25vw;
    height: 43vh;
    background: url("/static/images/e.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    margin-left: 2vw;
  }

  .right-infp {
    width: 80%;
    height: 42vh;
    margin: auto;
    vertical-align: center;
    position: absolute;
    top: 13vh;
    left: 2vw;
  }

  .aform {
    width: 100%;
  }

  .right-infp-name {
    background: url("/static/images/b.png") no-repeat;
    width: 100%;
    height: 5vh;
    background-size: 100% 100%;
    line-height: 5vh;
    margin-bottom: 2vh;
    position: relative;
  }

  .arco-form-item-content {
    height: 5rem;
    line-height: 5rem;
  }

  .arco-input-focus {
    width: 85%;
    border: none;
    box-sizing: border-box;
    height: 2rem;
    margin-left: 1rem;
    line-height: 2rem;
    background: none !important;
    color: #00eaff;
    outline: none;
    -webkit-tap-highlight-color: rgba(255, 0, 0, 0);
  }

  .arco-input-wrapper {
    width: 100%;
    background: none !important;
    color: #ffffff !important;
  }

  input::-webkit-input-placeholder {
    color: #ccc;
  }

  .right-infp-btn {
    background: url("/static/images/a.png") no-repeat;
    width: 100%;
    height: 3rem;
    background-size: 100% 100%;
    line-height: 3.5rem;
    margin-bottom: 1rem;
    position: relative;
    margin-top: 2vh;
    text-align: center;
  }

  .right-infp-btn .btn {
    width: 100%;
    border: none;
    box-sizing: border-box;
    height: 0.45rem;
    margin-left: 1rem;
    font-size: 1rem;
    cursor: pointer;
    background: none;
    outline: none;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/views/login.vue